export const defaultTheme = {
  background: "#121212",
  primary: "#2196F3",
  secondary: "#00BFA5",
  accent: "#82B1FF",
  error: "#F44336",
  info: "#2196F3",
  success: "#4CAF50",
  warning: "#FFC107",
  blackbox: "#010100",
  white: "#FFFFFF"
};



// WEBPACK FOOTER //
// ./src/theme.js